import { Button } from "@ews-admin/global-design-system";
import { useTranslation } from "react-i18next";

import { useOnlineStatus } from "../../../hooks/useOnlineStatus";
import { networkSlice, useNetworkState } from "../../../store/networkSlice";

/**
 * MED-1734: a thin bar at the top of the screen for patients on a bad 4G
 * link: above modals and the cookie banner (z-50, which sits at the bottom and
 * would hide it), without covering the cookie buttons. Offline wins over slow. "Annuler" aborts every pending request; the
 * aborted calls reject silently (no error modal). Renders nothing while idle,
 * so page snapshots are unaffected.
 */
export const SlowConnectionBanner = () => {
  const { t } = useTranslation();
  const { slow } = useNetworkState();
  const online = useOnlineStatus();

  if (online && !slow) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="network-banner"
      className="fixed inset-x-0 top-0 z-[60] flex items-center justify-center gap-3 bg-gray-900 px-4 py-2 text-sm text-white shadow-lg"
    >
      {online ? (
        <>
          <span
            aria-hidden="true"
            className="size-3 shrink-0 animate-spin rounded-full border-2 border-gray-500 border-t-white"
          />
          <span>{t("network.slowConnection")}</span>
          <Button
            type="button"
            size="sm"
            variant="ghost"
            className="text-white"
            onClick={networkSlice.cancelAll}
          >
            {t("network.cancel")}
          </Button>
        </>
      ) : (
        <span>{t("network.offline")}</span>
      )}
    </div>
  );
};

export default SlowConnectionBanner;
